import { render, staticRenderFns } from "./PremiumBanner.vue?vue&type=template&id=09d5f694&scoped=true"
import script from "./PremiumBanner.vue?vue&type=script&lang=js"
export * from "./PremiumBanner.vue?vue&type=script&lang=js"
import style0 from "./PremiumBanner.vue?vue&type=style&index=0&id=09d5f694&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d5f694",
  null
  
)

export default component.exports